import { Routing } from "@common/_constants";
import { ErrorService } from "@common/_services";
import { refetch } from "@common/_services/refetch";

export const SettingsService = {
    getAgentSettings,
    getContactSettings,
    getNotificationSettings,
    getSMSOptInStatus,

    saveAgentSettings,
    saveContactSettings,
    saveNotifications,
    saveSMSOptInStatus,

    lookupJobPositions,
    getManager,
    getEarnings,
    getPaymentUrl,
    getPaymentsHistoryUrl,
};

function getPaymentUrl(abortSignal: AbortSignal) {
    const requestOptions: RequestInit = {
        method: "GET",
        headers: { "Content-Type": "application/json" },
        signal: abortSignal,
    };
    const url = Routing.Api.Pro.Settings.GET_PAYMENTS_URL;
    return refetch(url, requestOptions)
        .then(resp => ErrorService.handleErrors(resp))
        .then(resp => resp.json())
        .then(apiResult => apiResult.result);
}

function getPaymentsHistoryUrl(abortSignal: AbortSignal) {
    const requestOptions: RequestInit = {
        method: "GET",
        headers: { "Content-Type": "application/json" },
        signal: abortSignal,
    };
    const url = Routing.Api.Pro.Settings.GET_PAYMENTS_HISTORY_URL;
    return refetch(url, requestOptions)
        .then(resp => ErrorService.handleErrors(resp))
        .then(resp => resp.json())
        .then(apiResult => apiResult.result);
}

function lookupJobPositions(term, includeAll, includeMy, abortSignal: AbortSignal) {
    const requestOptions: RequestInit = {
        method: "GET",
        headers: { "Content-Type": "application/json" },
        signal: abortSignal,
    };
    const url =
        Routing.Api.General.JobPositions.SUGGEST +
        `?term=${term}&includeAll=${includeAll}&includeMy=${includeMy}`;
    return refetch(url, requestOptions)
        .then(resp => ErrorService.handleErrors(resp))
        .then(resp => resp.json())
        .then(apiResult => apiResult.result);
}

function getContactSettings(abortSignal: AbortSignal) {
    const requestOptions: RequestInit = {
        method: "GET",
        headers: { "Content-Type": "application/json" },
        signal: abortSignal,
    };
    const url = Routing.Api.General.Profile.GET_CONTACT_SETTINGS;
    return refetch(url, requestOptions)
        .then(resp => ErrorService.handleErrors(resp))
        .then(resp => resp.json())
        .then(apiResult => apiResult.result);
}

function getAgentSettings(abortSignal: AbortSignal) {
    const requestOptions: RequestInit = {
        method: "GET",
        headers: { "Content-Type": "application/json" },
        signal: abortSignal,
    };
    const url = Routing.Api.General.Profile.GET_AGENT_SETTINGS;
    return refetch(url, requestOptions)
        .then(resp => ErrorService.handleErrors(resp))
        .then(resp => resp.json())
        .then(apiResult => apiResult.result);
}

function getNotificationSettings(abortSignal: AbortSignal) {
    const requestOptions: RequestInit = {
        method: "GET",
        headers: { "Content-Type": "application/json" },
        signal: abortSignal,
    };
    const url = Routing.Api.General.Profile.GET_NOTIFICATION_SETTINGS;
    return refetch(url, requestOptions)
        .then(resp => ErrorService.handleErrors(resp))
        .then(resp => resp.json())
        .then(apiResult => apiResult.result);
}

function getSMSOptInStatus(abortSignal: AbortSignal) {
    const requestOptions: RequestInit = {
        method: "GET",
        headers: { "Content-Type": "application/json" },
        signal: abortSignal,
    };
    const url = Routing.Api.General.Profile.SMS_OPT_IN_STATUS;
    return refetch(url, requestOptions)
        .then(resp => ErrorService.handleErrors(resp))
        .then(resp => resp.json())
        .then(apiResult => apiResult.result);
}

function saveNotifications(obj) {
    const requestOptions: RequestInit = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(obj),
    };
    const url = Routing.Api.General.Profile.SAVE_NOTIFICATION_SETTINGS;
    return refetch(url, requestOptions)
        .then(resp => ErrorService.handleErrors(resp))
        .then(resp => resp.json())
        .then(apiResult => apiResult);
}

function saveSMSOptInStatus(optInStatus) {
    const requestOptions: RequestInit = {
        method: "PUT",
        headers: {
            "Content-Type": "application/json; charset=utf-8",
            credentials: "include",
        },
        body: JSON.stringify(optInStatus),
    };

    const url = Routing.Api.General.Profile.SMS_OPT_IN_STATUS;
    return refetch(url, requestOptions)
        .then(resp => ErrorService.handleErrors(resp))
        .then(resp => resp.json())
        .then(apiResult => apiResult);
}

function saveAgentSettings(obj) {
    const requestOptions: RequestInit = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(obj),
    };
    const url = Routing.Api.General.Profile.SAVE_AGENT_SETTINGS;
    return refetch(url, requestOptions)
        .then(resp => ErrorService.handleErrors(resp))
        .then(resp => resp.json())
        .then(apiResult => apiResult);
}

function saveContactSettings(obj) {
    const url = Routing.Api.General.Profile.SAVE_CONTACT_SETTINGS;
    const settings: RequestInit = {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(obj),
    };
    return refetch(url, settings)
        .then(resp => ErrorService.handleErrors(resp))
        .then(resp => resp.json())
        .then(apiResult => apiResult);
}

function getManager(abortSignal: AbortSignal) {
    const url = Routing.Api.General.Profile.MANAGER;
    const settings: RequestInit = {
        method: "GET",
        headers: { "Content-Type": "application/json" },
        signal: abortSignal,
    };
    return refetch(url, settings)
        .then(resp => ErrorService.handleErrors(resp))
        .then(resp => resp.json())
        .then(json => json.result);
}

function getEarnings(abortSignal: AbortSignal) {
    const url = Routing.Api.General.Profile.EARNINGS;
    const settings: RequestInit = {
        method: "GET",
        headers: { "Content-Type": "application/json" },
        signal: abortSignal,
    };
    return refetch(url, settings)
        .then(resp => ErrorService.handleErrors(resp))
        .then(resp => resp.json())
        .then(json => json.result);
}
